"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionManager = void 0;
const __1 = require("..");
const StorageManager_1 = require("./StorageManager");
const PermissionValidator_1 = require("./PermissionValidator");
class PermissionManager {
    constructor(storage) {
        this.storageManager = new StorageManager_1.StorageManager(storage, __1.StorageKey.PERMISSION_LIST);
    }
    async getPermissions() {
        return this.storageManager.getAll();
    }
    async getPermission(accountIdentifier) {
        return this.storageManager.getOne((permission) => permission.accountIdentifier === accountIdentifier);
    }
    async addPermission(permissionInfo) {
        return this.storageManager.addOne(permissionInfo, (permission) => permission.accountIdentifier === permissionInfo.accountIdentifier);
    }
    async removePermission(accountIdentifier) {
        return this.storageManager.remove((permissionInfo) => permissionInfo.accountIdentifier === accountIdentifier);
    }
    async removePermissions(accountIdentifiers) {
        return this.storageManager.remove((permission) => accountIdentifiers.includes(permission.accountIdentifier));
    }
    async removeAllPermissions() {
        return this.storageManager.removeAll();
    }
    async hasPermission(message) {
        return PermissionValidator_1.PermissionValidator.hasPermission(message, this.getPermission.bind(this), this.getPermissions.bind(this));
    }
}
exports.PermissionManager = PermissionManager;
//# sourceMappingURL=PermissionManager.js.map